<mat-card appearance="outlined" *ngIf="application">
  <mat-card-header>
    <mat-card-title>
      {{application.name}} Metadata Sets
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div class="row">
      <div class="col-md-8">
        <mat-form-field appearance="fill" floatLabel="always" class="full-width">
          <mat-label>Metadata Set</mat-label>
          <mat-select placeholder="<Select Set>" [(ngModel)]="selectedSet" (selectionChange)="onChangeSet($event)"
            name="setSelect">
            <mat-option [value]="set" *ngFor="let set of metadataSets">
              {{set.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <button mat-raised-button color="accent" (click)="addNew()">Add Set</button>
      </div>
    </div>
    <div class="row" *ngIf="selectedSet">
      <div class="col-md-8">
        <mat-form-field appearance="fill" floatLabel="always" class="full-width">
          <mat-label>Set Title</mat-label>
          <input [(ngModel)]="selectedSet.title" matInput placeholder="Set Title" name="title">
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="selectedSet">
      <div class="col-md-8">
        <mat-form-field appearance="fill" floatLabel="always" class="full-width">
          <mat-label>Set Description</mat-label>
          <textarea rows="5" matInput placeholder="Description" [(ngModel)]="selectedSet.comments"
            name="comments"></textarea>
        </mat-form-field>
      </div>
      <div class="col-md-4">
        <button mat-raised-button color="accent" (click)="updateComments()">Update Set</button>
      </div>
    </div>

    <mat-table [dataSource]="dataSource">
      <!-- Name Column -->
      <ng-container matColumnDef="definitionName">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{row.currentData.definitionName}}
        </mat-cell>
      </ng-container>

      <!-- Type Column -->
      <ng-container matColumnDef="definitionType">
        <mat-header-cell *matHeaderCellDef> Type </mat-header-cell>
        <mat-cell *matCellDef="let row">
          {{row.currentData.definitionType}}
        </mat-cell>
      </ng-container>

      <!-- Default Value Column -->
      <ng-container matColumnDef="default">
        <mat-header-cell *matHeaderCellDef> Default Value </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div *ngIf="row.currentData.definitionType == 'DateTime'; else normalBlock">
            {{row.currentData.definitionValue|date:'mediumDate'}}
          </div>
          <ng-template #normalBlock>{{row.currentData.definitionValue}}</ng-template>
        </mat-cell>
      </ng-container>

      <!-- Value Column -->
      <ng-container matColumnDef="value">
        <mat-header-cell *matHeaderCellDef> Set Override Value </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-form-field floatLabel="{{ row.editing ? 'float' : 'never'}}">
            <div [ngSwitch]="row.currentData.definitionType">
              <div *ngSwitchCase="'DateTime'">
                <input name="{{row.id}}" [(ngModel)]="row.currentData.value" [readonly]="!row.editing" matInput
                  [matDatepicker]="tablepicker">
                <mat-datepicker-toggle matSuffix [for]="tablepicker" [hidden]="!row.editing"></mat-datepicker-toggle>
                <mat-datepicker #tablepicker disabled="false"></mat-datepicker>
              </div>
              <div *ngSwitchCase="'Text'">
                <input name="{{row.id}}" [(ngModel)]="row.currentData.value" [readonly]="!row.editing" matInput>
              </div>
              <div *ngSwitchCase="'Value'">
                <input type="number" name="{{row.id}}" [(ngModel)]="row.currentData.value" [readonly]="!row.editing"
                  matInput>
              </div>
              <div *ngSwitchDefault>
                <input name="{{row.id}}" [(ngModel)]="row.currentData.value" [readonly]="!row.editing" matInput>
              </div>
            </div>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actionsColumn">
        <mat-header-cell *matHeaderCellDef>

        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button *ngIf="!row.editing" mat-icon-button color="primary" focusable="false" (click)="startEditConfirm(row)"
            matTooltip="Edit value.">
            <mat-icon>create</mat-icon>
          </button>
          <button *ngIf="row.editing" mat-icon-button color="primary" focusable="false"
            (click)="createOrEditConfirm(row)" matTooltip="Save edit.">
            <mat-icon>check</mat-icon>
          </button>
          <button *ngIf="row.editing" mat-icon-button color="primary" focusable="false"
            (click)="cancelOrDeleteConfirm(row)" matTooltip="Cancel edit.">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

    <div *ngIf="selectedSet">
      <button mat-raised-button color="warn" (click)="deleteSelected()">Delete Set</button>
    </div>

  </mat-card-content>
</mat-card>